import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-media-gallery-edit-dialog',
  templateUrl: './media-gallery-edit-dialog.component.html',
  styleUrls: ['./media-gallery-edit-dialog.component.scss']
})
export class MediaGalleryEditDialogComponent implements OnInit {

  imagesDuration;
  videosCycles;
  htmlsDuration;
  htmlsZoomLevel;
  zoomValues = [25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 250, 300, 400, 500]

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              public dialogRef: MatDialogRef<MediaGalleryEditDialogComponent>) { }

  ngOnInit() {
  }

  public save() {
    this.dialogRef.close({imagesDuration: this.imagesDuration, videosCycles: this.videosCycles, htmlsDuration: this.htmlsDuration, htmlsZoomLevel: this.htmlsZoomLevel});
  }

  public cancel() {
    this.dialogRef.close();
  }

  public getSelectedImagesLength() {
    if (this.data) {
      return this.data.selectedImages.length;
    }
  }
  public getSelectedVideosLength() {
    if (this.data) {
      return this.data.selectedVideos.length;
    }
  }
  public getSelectedHtmlLength() {
    if (this.data) {
      return this.data.selectedHtmls.length;
    }
  }
}
